module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/icon-fit-to-height.6970bba5943cec7f63c245eccf0d86e1.svg";